@if (targetingSearch) {
    @if (targetingSearch?.id) {
        <agpr-panel
            header="Discover.targeting.panels.searchDetails"
            [marginTop]="0"
        >
            <agpr-attribute-list
                [attributes]="targetingSearch.attributes"
            ></agpr-attribute-list>
        </agpr-panel>
    }

    <agpr-panel
        header="Discover.targeting.panels.searchQuery"
        [marginTop]="10"
    >
        <div class="agpr-targetingSearch-summary-container">
            @if (!targetingSearch.subjects.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.subjects' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.subjects"
                        labelLookupValue="name"
                        labelLookupKey="id"
                        [labelLookup]="journodexSubjectsService.getChildrenByIds.bind(journodexSubjectsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.monitoringKeywords.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.keywords' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.monitoringKeywords"
                    ></agpr-filter-summary>
                </div>
            }
                
            @if (!targetingSearch.outletSubjects.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.universal.outlet' | localize }} {{ 'Discover.targeting.searchFieldLabels.subjects' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.outletSubjects"
                        labelLookupValue="name"
                        labelLookupKey="id"
                        [labelLookup]="journodexSubjectsService.getChildrenByIds.bind(journodexSubjectsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.outletMonitoringKeywords.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.universal.outlet' | localize }} {{ 'Discover.targeting.searchFieldLabels.keywords' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.outletMonitoringKeywords"
                    ></agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.geographies.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.regions' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.geographies"
                        labelLookupValue="displayString"
                        labelLookupKey="collectionId"
                        [labelLookup]="journodexRegionsService.getByGeographyIds.bind(journodexRegionsService)">
                    </agpr-filter-summary>
                </div> 
            }

            @if (!targetingSearch.areasOfCoverage.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.targetAudienceRegion' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.areasOfCoverage"
                        labelLookupValue="displayString"
                        labelLookupKey="collectionId"
                        [labelLookup]="journodexRegionsService.getByGeographyIds.bind(journodexRegionsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.mediaMarkets.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.mediaMarkets' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.mediaMarkets"
                        labelLookupValue="displayString"
                        labelLookupKey="id"
                        [labelLookup]="journodexEnumsService.getMediaMarketsByIds.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.languages.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.languages' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.languages"
                        labelLookupValue="name"
                        labelLookupKey="id"
                        [labelLookup]="localizationService.getLanguagesById.bind(localizationService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.jobRoles.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.jobRoles' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.jobRoles"
                        labelLookupValue="displayString"
                        labelLookupKey="id"
                        [labelLookup]="journodexEnumsService.getJobRolesByIds.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.jobTitles.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.jobTitles' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.jobTitles"
                    ></agpr-filter-summary>
                </div> 
            }

            @if (!targetingSearch.contactIdsNames.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.contact.names' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        includeExcludeKey="name"
                        [(ngModel)]="targetingSearch.contactIdsNames"
                    ></agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.outletIdsNames.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.outletNames' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        includeExcludeKey="name"
                        [(ngModel)]="targetingSearch.outletIdsNames"
                    ></agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.mediaTypes.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.mediaTypes' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.mediaTypes"
                        labelLookupValue="displayString"
                        labelLookupKey="enumValue"
                        [labelLookup]="journodexEnumsService.getMediaTypes.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.productTypes.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.productTypes' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.productTypes"
                        labelLookupValue="displayString"
                        labelLookupKey="enumValue"
                        [labelLookup]="journodexEnumsService.getProductTypes.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.marketSectors.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.marketSectors' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.marketSectors"
                        labelLookupValue="displayString"
                        labelLookupKey="enumValue"
                        [labelLookup]="journodexEnumsService.getMarketSectors.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.coverageFocuses.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.coverageFocuses' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.coverageFocuses"
                        labelLookupValue="displayString"
                        labelLookupKey="enumValue"
                        [labelLookup]="journodexEnumsService.getCoverageFocuses.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.productFrequencies.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.productFrequencies' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.productFrequencies"
                        labelLookupValue="displayString"
                        labelLookupKey="enumValue"
                        [labelLookup]="journodexEnumsService.getProductFrequencies.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (!targetingSearch.targetAudiences.isEmpty()) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.searchFieldLabels.targetAudiences' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    <agpr-filter-summary
                        [(ngModel)]="targetingSearch.targetAudiences"
                        labelLookupValue="displayString"
                        labelLookupKey="enumValue"
                        [labelLookup]="journodexEnumsService.getTargetAudiences.bind(journodexEnumsService)">
                    </agpr-filter-summary>
                </div>
            }

            @if (targetingSearch.audienceReachFilter?.type &&
                (targetingSearch.audienceReachFilter?.range?.min !== null || 
                targetingSearch.audienceReachFilter?.range?.max !== null)
            ) {
                <label class="agpr-targetingSearch-summary-label">
                    {{ 'Discover.targeting.filter.audienceReach' | localize }}
                </label>
                <div class="agpr-targetingSearch-summary-details">
                    @if (targetingSearch.audienceReachFilter.range.min === null) {
                        {{ 'Common.filter.range.lessThan' | localize : {
                            name: circulationNameMap.get(targetingSearch.audienceReachFilter.type),
                            max: targetingSearch.audienceReachFilter.range.max | number:'1.0-2',
                        } }}
                    } @else if (targetingSearch.audienceReachFilter.range.max === null) {
                        {{ 'Common.filter.range.greaterThan' | localize : {
                            name: circulationNameMap.get(targetingSearch.audienceReachFilter.type),
                            min: targetingSearch.audienceReachFilter.range.min | number:'1.0-2',
                        } }}
                    } @else {
                        {{ 'Common.filter.range.minToMax' | localize : {
                            name: circulationNameMap.get(targetingSearch.audienceReachFilter.type),
                            min: targetingSearch.audienceReachFilter.range.min | number:'1.0-2',
                            max: targetingSearch.audienceReachFilter.range.max | number:'1.0-2', 
                        } }}
                    }
                </div>
            }
        </div>
    </agpr-panel>
}

@if (targetingList?.id) {
    <agpr-panel
        [marginTop]="0"
        header="Discover.targeting.panels.listDetails"
    >
        <agpr-attribute-list
            [attributes]="targetingList.attributes"
        ></agpr-attribute-list>
    </agpr-panel>
}
